// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3cWhf","inputWrap":"CustomTip_inputWrap__32n7L"};